
import React, {PureComponent} from 'react';
import Footer from '../Footer';
import Header from '../Header';


class MainLayout extends PureComponent {

    constructor(props) {
        super(props); 
    }
 	render() {
        const {props} = this;
        return (
            <>
                <Header {...props} />
                <props.component   {...props} />
                <Footer />
            </>
        );
    }
};

export default MainLayout;
